module.exports = __webpack_public_path__ + "img/star.6da7d173.svg";